import { createContext } from 'react';

/**
 * Theme context.
 *
 * Lives in its own module so `ThemeProvider` and `useTheme` can both reference it
 * without importing each other, and so the file-per-component rule holds.
 *
 * @typedef {object} ThemeContextValue
 * @property {'system'|'light'|'dark'} preference   What the user chose.
 * @property {'light'|'dark'} resolvedTheme         The palette actually in use.
 * @property {(next: 'system'|'light'|'dark') => void} setThemePreference
 * @property {() => void} toggleTheme              Flips between light and dark.
 */

/** @type {import('react').Context<ThemeContextValue | null>} */
export const ThemeContext = createContext(null);
